import SupportActionType from '../../common/SupportActionType';

const initialState = {
  categories: {},
  categoriesPending: false
};

const supportReducer = (state = initialState, action) => {
  switch (action.type) {
    case SupportActionType.FETCH_CATEGORIES:
      return {
        ...state,
        categoriesPending: true
      };
    case SupportActionType.STORE_CATEGORIES:
      return {
        ...state,
        categories: { ...action.categories },
        categoriesPending: false
      };
    case SupportActionType.FETCH_ARTICLES:
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.id]: { ...state.categories[action.id], articlesPending: true }
        }
      };
    case SupportActionType.STORE_ARTICLES:
      return {
        ...state,
        categories: {
          ...state.categories,
          [action.id]: { ...state.categories[action.id], articles: action.articles, articlesPending: false }
        }
      };
    default:
      return state;
  }
};

const getCategories = (state) => {
  const support = state.support;
  const categoryKeys = Object.keys(support.categories);

  return categoryKeys.map(key => ({
    id: key,
    title: support.categories[key].title,
    description: support.categories[key].description,
    uri: support.categories[key].uri
  }));
};

export const supportSelector = {
  getCategories,
  getCategoriesPending: state => state.support.categoriesPending,
  getCategory: (id, state) => state.support.categories[id] || {}
};

export default supportReducer;



/** WEBPACK FOOTER **
 ** ./src/redux/reducers/SupportReducer.js
 **/